var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "64px",
    width: "64px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    stroke: "#000000",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.667,213.333c-11.782,0-21.333,9.551-21.333,21.333V256c0,82.469-66.865,149.333-149.333,149.333 S106.667,338.469,106.667,256v-21.333c0-11.782-9.551-21.333-21.333-21.333c-11.782,0-21.333,9.551-21.333,21.333V256 c0,98.821,74.674,180.199,170.667,190.814v22.519H192c-11.782,0-21.333,9.551-21.333,21.333S180.218,512,192,512h128 c11.782,0,21.333-9.551,21.333-21.333s-9.551-21.333-21.333-21.333h-42.667v-22.519C373.326,436.199,448,354.821,448,256v-21.333 C448,222.885,438.449,213.333,426.667,213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,384c70.683,0,128-57.317,128-128V128C384,57.317,326.683,0,256,0S128,57.317,128,128v128 C128,326.683,185.317,384,256,384z M170.667,128c0-47.119,38.214-85.333,85.333-85.333S341.333,80.881,341.333,128v128 c0,47.119-38.214,85.333-85.333,85.333S170.667,303.119,170.667,256V128z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.0f504f4890b347aed48a0be8a83e2e31.svg";
export { ForwardRef as ReactComponent };